import {updatePartnerPassword} from "../Util/queries";
import {constructPartnerDetails} from "../Factory/factory";
import {PARTNER_DETAILS} from "./partnerDetailsAction";

const PARTNER_PROFILE_UPDATE_STATE = "PARTNER_PROFILE_UPDATE_STATE";
const PROFILE_UPDATE_SUCCESSFUL = "PROFILE_UPDATE_SUCCESSFUL";
const PROFILE_UPDATE_FAILED = "PROFILE_UPDATE_FAILED";

export const updateProfileInfo = (data) => async (dispatch) => {
    try {
        dispatch({
            type: PARTNER_PROFILE_UPDATE_STATE,
            payload: null
        })
        let response = await updatePartnerPassword(data);
        if (response.data) {
            let detailsData = response.data;
            let partnerDetailsObj = constructPartnerDetails(detailsData.id, detailsData.partnerType, detailsData.address, detailsData.billingAddress, detailsData.billingDiscountPercent, detailsData.companyName, detailsData.contactPerson, detailsData.titleOfContactPerson, detailsData.email, detailsData.phoneNumber, detailsData.secret);
            dispatch({
                type: PARTNER_DETAILS,
                payload: partnerDetailsObj
            })
            dispatch({
                type: PARTNER_PROFILE_UPDATE_STATE,
                payload: PROFILE_UPDATE_SUCCESSFUL
            })
        } else {
            dispatch({
                type: PARTNER_PROFILE_UPDATE_STATE,
                payload: PROFILE_UPDATE_FAILED
            })
        }
    } catch (e) {
        console.error(e);
        dispatch({
            type: PARTNER_PROFILE_UPDATE_STATE,
            payload: PROFILE_UPDATE_FAILED
        })
    }
}

export {PARTNER_PROFILE_UPDATE_STATE, PROFILE_UPDATE_SUCCESSFUL, PROFILE_UPDATE_FAILED}
